import { Suspense, lazy, useState } from "react";

const AiAssistant = lazy(() =>
  import("./ai-assistant").then((m) => ({ default: m.AiAssistant })),
);

/**
 * Renders only a lightweight launcher button. The chat widget (and its
 * AI SDK dependencies) is downloaded the first time the user opens it.
 */
export function AiAssistantLazy() {
  const [loaded, setLoaded] = useState(false);

  if (loaded) {
    return (
      <Suspense fallback={null}>
        <AiAssistant defaultOpen />
      </Suspense>
    );
  }

  return (
    <button
      type="button"
      aria-label="Open AI assistant"
      onClick={() => setLoaded(true)}
      onMouseEnter={() => {
        void import("./ai-assistant");
      }}
      className="fixed bottom-5 right-5 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-brand-accent text-white shadow-lg shadow-brand-accent/30 transition-transform hover:scale-105 active:scale-95"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <circle cx="9" cy="10" r="1" fill="currentColor" />
        <circle cx="13" cy="10" r="1" fill="currentColor" />
        <circle cx="17" cy="10" r="1" fill="currentColor" />
      </svg>
    </button>
  );
}
